<template>
  <div>
    <sub-header-component
      :title="getLocalized(contentData, 'title')"
      :description="getLocalized(contentData, 'description')"
    ></sub-header-component>
    <div class="p-4 pt-12 md:p-[50px] lg:p-[100px] flex flex-col gap-[40px]">
      <sub-service-card
        v-for="(item, index) in subSoftwareSolutionData"
        :key="index"
        :img="item.image_path"
        :title="getLocalized(item, 'name')"
        :description="getLocalized(item, 'description')"
      ></sub-service-card>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import SubServiceCard from "../../components/Home/subServiceCard.vue";
import { useLocalization } from "@/composable/useLocalization";
import { fetchContentSection } from "@/composable/apiService";
import SubHeaderComponent from "./subHeaderComponent.vue";
export default {
  components: {
    SubServiceCard,
    SubHeaderComponent,
  },

  data() {
    return {
      subSoftwareSolutionData: [],
      api: process.env.VUE_APP_API_KEY,
      contentData: {},
      currentLang: localStorage.getItem("language") || "en",
    };
  },
  computed: {
    // Optionally, you can use a computed property for localization logic
    getLocalized() {
      const { getLocalized } = useLocalization();
      return getLocalized;
    },
  },
  mounted() {
    this.fetchSubSoftwareSolution();
  },
  methods: {
    async fetchSubSoftwareSolution() {
      try {
        this.contentData = await fetchContentSection(10);
        const response = await axios.get(
          this.api + "/api/sub-services/?page=1&page_size=20"
        );
        this.subSoftwareSolutionData = response.data.items
          .map((item) => ({
            ...item,
            image_path: `${this.api}${item.image_path}`,
          }))
          .filter((item) => item.main_service_id === 4)
          .sort((a, b) => a.display_order - b.display_order);
      } catch (error) {
        console.error(error.message);
      }
    },
  },
};
</script>

<style></style>
